module.exports = __webpack_public_path__ + "img/app-logo.d40ec52f.png";